import { IntegrationType } from '../../../../api/integrations-client/integrations-client.type';
import type { ProjectsResponse } from '../../../../api/projects-client/projects-client.type';
import { getDataSourceIcon, getDataSourceLabel } from '../data-management.helpers';
import { PanelList } from '../panel-list';

type ProjectsListProps = {
  projects: ProjectsResponse[];
  selectedProject: ProjectsResponse | null;
  setSelectedProject: (project: ProjectsResponse) => void;
  onCreateProject: () => void;
};

export function ProjectsList({ projects, selectedProject, setSelectedProject, onCreateProject }: ProjectsListProps) {
  return (
    <PanelList
      title="Projects"
      items={projects}
      selectedItem={selectedProject}
      onAddNew={onCreateProject}
      onSelect={(project) => setSelectedProject(project)}
      getItemId={(project) => project.id}
      getItemDisplayText={(project) => project.name}
      getItemIcon={(project) => (
        <img
          src={getDataSourceIcon(project.pm_tool as IntegrationType)}
          width={20}
          height={20}
          alt={getDataSourceLabel(project.pm_tool as IntegrationType)}
        />
      )}
    />
  );
}
